<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Edit employee"></aw-bread-crumb>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Edit Employee Details'"
    [altColor]="false"
    style="width: 300px"
  >
  </aw-divider>
  @if (employeeInfo) {
  <div>
    <div class="form-container">
      @for (item of employeeTextForms(); track $index) {
      <app-aw-text-form
        class="input"
        [readOnly]="item.readOnly"
        [required]="item.required"
        [title]="item.title"
        [value]="item.value"
        (textEntry)="item.textEntryActionHandler($event)"
      ></app-aw-text-form>
      }

      <app-aw-dropdown-form
        class="input"
        [required]="true"
        [options]="statusOptions()"
        [label]="''"
        title="Status"
        (currentOption)="onEmployeeStatusSelected($event)"
      ></app-aw-dropdown-form>
    </div>
  </div>
  }
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
